import { render, staticRenderFns } from "./DealerStatus.vue?vue&type=template&id=723912b6&"
import script from "./DealerStatus.vue?vue&type=script&lang=js&"
export * from "./DealerStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports